import { Flex, Text } from '@mantine/core';
import React from 'react';
import { UserInitialsBadge } from '@dealstack/frontend/shared/components/UserInitialsBadge/UserInitialsBadge.tsx';
import { EditableTileContainer } from '@dealstack/frontend/shared/components/EditableTileContainer/EditableTileContainer.tsx';
import { StyledLink } from '@dealstack/frontend/shared/components/UserRowWithActions/styled.tsx';

interface Props {
	displayName: string;
	/** Secondary line under the name, e.g. an OTHER controlling party's custom role. */
	subtitle?: string | null;
	userLink?: string;
	onUserEditClick?: () => void;
	onUserDeleteClick?: () => void;
	hasEditPermission: boolean;
	showInitialsAvatar?: boolean;
	dataTestId?: string;
	editBtnDataTestId?: string;
	deleteBtnDataTestId?: string;
}

export const UserRowWithActions = ({
	displayName,
	subtitle,
	userLink,
	onUserEditClick,
	onUserDeleteClick,
	hasEditPermission,
	showInitialsAvatar = true,
	dataTestId,
	editBtnDataTestId,
	deleteBtnDataTestId,
}: Props) => {
	const [firstName, lastName] = displayName.split(' ');
	const nameElement = (
		<Text variant="h6" lineClamp={1} fw={600} truncate style={{ wordBreak: 'break-all' }}>
			{displayName}
		</Text>
	);
	return (
		<EditableTileContainer
			hasEditPermission={hasEditPermission}
			onEditClick={onUserEditClick}
			onDeleteClick={onUserDeleteClick}
			dataTestId={dataTestId}
			editBtnDataTestId={editBtnDataTestId}
			deleteBtnDataTestId={deleteBtnDataTestId}
		>
			<Flex align="center" gap="0.5rem">
				{showInitialsAvatar && (
					<UserInitialsBadge firstName={firstName} lastName={lastName} textVariant="xs" />
				)}
				<Flex direction="column">
					{userLink ? <StyledLink to={userLink}>{nameElement}</StyledLink> : nameElement}
					{subtitle && (
						<Text
							variant="sm"
							c="dark.0"
							lineClamp={1}
							truncate
							style={{ wordBreak: 'break-all' }}
						>
							{subtitle}
						</Text>
					)}
				</Flex>
			</Flex>
		</EditableTileContainer>
	);
};
